export const PROMOCODE_MAX_LENGTH = 6;

export const PROMOCODE_ITEM_STATUSES = {
	CREATED: 'created',
	ACTIVATED: 'activated',
	COMPLETED: 'completed',
	CANCELED: 'canceled',
} as const;

export type PromocodeItemStatus =
	(typeof PROMOCODE_ITEM_STATUSES)[keyof typeof PROMOCODE_ITEM_STATUSES];
